import React from "react";
import classNames from "classnames";
import ClipLoader from 'react-spinners/ClipLoader';
import {Button} from "reactstrap";
import {Card, CardContent} from "@material-ui/core";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

export default class Kiosks extends Framework.Components.Collection {
	constructor(props) {
		const model = new API.BuildClass(Types.Kiosks._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.limit = 16;
	}

	render() {
		const {data, pages, loading, limit} = this.state;
		const columns = [
			{
				Header: "Name",
				accessor: "name",
				Cell: props => <Link to={`/kiosks/${props.original.pkey}`}>{props.value || '-'}</Link>
			},
			{
				Header: "Paired",
				accessor: "api_key",
				Cell: props => <span>{props.value ? "Yes" : "No"}</span>
			},
			{
				Header: "Created",
				accessor: "created",
				Cell: props => <span>{props.value || '-'}</span>
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => (
					<span>
						<Link to={`/kiosks/${props.original.pkey}`}>
							<Button color="green-meadow" size={"sm"} block={true}>
								<i className={"fa fa-pencil"}/>
							</Button>
						</Link>
					</span>
				)
			}
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Kiosks')}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={(tableState) => {
							this.tableState = tableState;
							this.fetchData(tableState);
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						onPageSizeChange={this.onPageSizeChange}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
					/>
					{APPCONFIG.settings.isDev() ? null :
						<div className={classNames("tabled", "loader", {'active': loading})}>
							<ClipLoader color={"#4A4A4A"} loading={loading}/>
						</div>
					}
				</CardContent>
			</Card>
		);
	}
}
